import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import {SingleValue} from 'react-select';
import InputTypeAhead from '../../../../common/components/ui/InputTypeAhead';
import {useReceiptsGridContext} from '../ReceiptsGridContext';
import search from '../../../../common/assets/icons/search.svg';
import styles from './FieldCustomerID.module.scss';

type Option = {label: string, value:string};

const FieldCustomerID = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'receipts-col-customer',
    defaultMessage: 'Customer'
  });
  const [field, meta, helper] = useField({name: 'customerID'});
  const {loadOptions} = useReceiptsGridContext();

  const handleChange = (option: SingleValue<Option>) => {
    helper.setValue(option?.value || null);
  };

  const inputValue = field?.value
    ? {label: field.value, value: field.value}
    : {label: '', value: ''};

  return (
    <div className={styles.searchContainer}>
      <InputTypeAhead
        <Option, false>
        {...field}
        {...meta}
        id={field.name}
        placeholder={labelText}
        value={inputValue}
        loadOptions={loadOptions}
        onChange={handleChange}
      />
      <img
        src={search}
        alt="search"
        className={styles.searchIcon}
      />
    </div>
  );
};

export default FieldCustomerID;
